
import { Component, Vue } from 'vue-property-decorator';
import OsInputTextField from '@/components/core/input/OsInputTextField.vue';
import OsButton from '@/components/core/OsButton.vue';
import {
  ILoginRequest,
  ILoginResponse,
  LoginResponseType
} from '@/models/authentication';
import OsCard from '@/components/core/card/OsCard.vue';
import OsCardText from '@/components/core/card/OsCardText.vue';
import OsAlertBox from '@/components/core/OsAlertBox.vue';
import { authenticationApi } from '@/apis';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import { defaultRoutes } from '@/router/default-routes';

@Component({
  components: {
    OsSheet,
    OsAlertBox,
    OsCardText,
    OsCard,
    OsButton,
    OsInputTextField
  }
})
export default class Login extends Vue {
  loading = false;
  info: string | null = null;
  passwordVisible = false;
  loginRequest: ILoginRequest = {
    emailaddress: '',
    password: ''
  };

  async mounted() {
    const localAuthenticated = this.$store.getters['auth/isAuthenticated'];

    if (localAuthenticated) {
      const serverAuthenticated = await authenticationApi.checkAuthentication();

      if (serverAuthenticated) {
        await this.navigateToPostLoginPage();
      }
    }
  }

  async login() {
    this.info = null;

    if (this.loginRequest.emailaddress === '') {
      this.info = this.$tc('page.login.notification.missing_username');
      return;
    }

    if (this.loginRequest.password === '') {
      this.info = this.$tc('page.login.notification.missing_password');
      return;
    }

    this.loading = true;

    this.loginRequest.emailaddress = this.loginRequest.emailaddress.trim();

    try {
      const result: ILoginResponse = await this.$store.dispatch(
        'auth/login',
        this.loginRequest
      );

      if (result.type === LoginResponseType.Success) {
        if (
          !this.$global.roles.isInRole('customerportal_user') &&
          !this.$global.roles.isInRole('customerportal_admin') &&
          !this.$global.roles.isInRole('customerportal_trial')
        ) {
          this.info = this.$tc('page.login.notification.user_not_found');
          await this.$store.dispatch('auth/logout', this.loginRequest);
          return;
        }

        await this.navigateToPostLoginPage();
        return;
      }

      switch (result.type) {
        case LoginResponseType.EmailNotConfirmed:
          this.info = this.$tc('page.login.notification.email_not_confirmed');
          break;
        case LoginResponseType.UserNotFound:
          this.info = this.$tc('page.login.notification.user_not_found');
          break;
        case LoginResponseType.WrongPassword:
          this.info = this.$tc('page.login.notification.wrong_password');
          break;
        case LoginResponseType.InvalidUserState:
          this.info = this.$tc('page.login.notification.user_deactivated');
          break;
        default:
          this.info = this.$tc('page.login.notification.general_login_error');
          break;
      }
    } finally {
      this.loading = false;
    }
  }

  async navigateToPostLoginPage() {
    if (this.$route.path != defaultRoutes.postLogin) {
      await this.$router.push(defaultRoutes.postLogin);
    }
  }
}
